exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-icon[data-v-c7b3e64a] {\n  margin-top: 12px;\n}\n.datasheet-record-edit-mode-file-max-size[data-v-c7b3e64a] {\n  color: #bc7610;\n}\n", ""]);

// exports
